/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Seating_Open_SeatInputs */



/**
* | output |
* | --- |
* | "Open seat" |
*
* @param {Rounds_Seating_Open_SeatInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seating_open_seat = /** @type {((inputs?: Rounds_Seating_Open_SeatInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seating_Open_SeatInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Placement libre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asiento libre")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assento livre")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posto libero")
	return /** @type {LocalizedString} */ ("Open seat")
});